import {
  Typography,
  Row,
  Col,
  Card,
  Select,
  Table,
  DatePicker,
  Button,
} from 'antd'
import { useState, useEffect, useRef } from 'react'
import { DownloadOutlined } from '@ant-design/icons'
import html2canvas from 'html2canvas'
import dayjs from 'dayjs'
import {
  getAvatarDashboardMetrics,
  getTop10AvatarMetrics,
  getTop10CustomAvatarMetrics,
  getAvatarDashboardChart,
} from 'src/api/reports'
import './socialoverview.css'
import moment from 'moment'
import { fetchCountryProvider } from 'src/api/authen'
import DailyChatChart from 'src/components/Charts/DailyChatChart'
import AvatarPieChart from 'src/components/Charts/AvatarPieChart'
import AvatarCustomTimeseries from 'src/components/Charts/AvatarCustomTimeSeries'
import ProviderCountrySelect from 'src/components/Input/ProviderCountrySelect'

const { Title } = Typography
const { Column } = Table
const { RangePicker } = DatePicker

const AvatarOverview = () => {
  
const [selectedCountryValue, setSelectedCountryValue] = useState<
  string[]
>(['TN']);
  
  const [loading, setLoading] = useState(true)
  const [socialChartData, setSocialChartData] = useState([])
  const [socialChatData, setSocialChatData] = useState([])
  
  const [socialDeviceData, setSocialDeviceData] = useState([])
  const [sociaGenderData, setSocialGenderData] = useState([])
  const [top10AvatarsLoading, setTop10AvatarsLoading] = useState(false)
  const [top10CustomAvatarsloading, setTop10CustomAvatarsloading] = useState(false)
   const [startDate, setStartDate] = useState(
      moment().startOf('day').subtract(1, 'week')
    )
    const [endDate, setEndDate] = useState(moment().startOf('day'))
  const [countries, setCountries] = useState([])
  const cardRefs = useRef([])
  const [top10AvatarData, setTop10AvatarData] = useState([])
  const [top10CustomAvatarData, setTop10CustomAvatarData] = useState([])
  const [avatarChart, setAvatarChart] = useState([])
const [metricsData, setMetricsData] = useState<AvatarDashboardMetricsDto>({
     totalAvatarCount: 0,
  totalCustomCharacterCount: 0,
  avatarPercentage: 0,
  characterPercentage: 0,
  });
  const pieChartData = [
    {
      key: 'Characters',
      value: metricsData.avatarPercentage,
    },
    {
      key: 'Customized',
      value: metricsData.characterPercentage,
    },
  ];
  const handleDownload = async (index) => {
    if (!cardRefs.current[index]) return

    const canvas = await html2canvas(cardRefs.current[index], {
      scale: 2,
      ignoreElements: (element) => element.classList.contains('no-snapshot'),
    })
    const image = canvas.toDataURL('image/png')

    const link = document.createElement('a')
    link.href = image
    link.download = `card_snapshot_${index + 1}.png`
    link.click()
  }

   
        const fetchAvatarDashboardMetricsData = async () => {
          try {
            const payload = {
              providerCountry: selectedCountryValue,
                startDate: startDate ? startDate.format('YYYY-MM-DD') : undefined,
                endDate: endDate ? endDate.format('YYYY-MM-DD') : undefined,
            }
            const data = await getAvatarDashboardMetrics(payload)
            if (data) {
              setMetricsData(data)
            }
          } catch (error) {
            console.error('Error fetching avatar metrics:', error)
          }
        }
        const fetchTop10AvatarDashboardMetricsData = async () => {
          try {
            const payload = {
              providerCountry: selectedCountryValue,
                startDate: startDate ? startDate.format('YYYY-MM-DD') : undefined,
                endDate: endDate ? endDate.format('YYYY-MM-DD') : undefined,
            }
            const data = await getTop10AvatarMetrics(payload)
            if (data) {
              setTop10AvatarData(data)
            }
          } catch (error) {
            console.error('Error fetching top10 avatar metrics:', error)
          }
        }
        const fetchTop10CustomAvatarDashboardMetricsData = async () => {
          try {
            const payload = {
              providerCountry: selectedCountryValue,
                startDate: startDate ? startDate.format('YYYY-MM-DD') : undefined,
                endDate: endDate ? endDate.format('YYYY-MM-DD') : undefined,
            }
            const data = await getTop10CustomAvatarMetrics(payload)
            if (data) {
              setTop10CustomAvatarData(data)
            }
          } catch (error) {
            console.error('Error fetching avatar metrics:', error)
          }
        }
        const fetchAvatarDashboardChart = async () => {
          try {
            const payload = {
              providerCountry: selectedCountryValue,
                startDate: startDate ? startDate.format('YYYY-MM-DD') : undefined,
                endDate: endDate ? endDate.format('YYYY-MM-DD') : undefined,
            }
            const data = await getAvatarDashboardChart(payload)
            if (data) {
              setAvatarChart(data)
            }
          } catch (error) {
            console.error('Error fetching avatar metrics:', error)
          }
        }
      

        useEffect(() => {
          fetchAvatarDashboardMetricsData()
          fetchTop10AvatarDashboardMetricsData()
          fetchTop10CustomAvatarDashboardMetricsData()
          fetchAvatarDashboardChart()
      }, [startDate, endDate, selectedCountryValue])
    
 
  const fetchCountry = async () => {
    try {
      const data = await fetchCountryProvider()
      const countryOptions = [
        { label: 'All', value: null },
        ...data.data.map((item) => ({
          label: item.countryName,
          value: item.countryCode,
        })),
      ]
      setCountries(countryOptions)
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }

  useEffect(() => {
    fetchCountry()
   
  }, [])
  
 const handleCountryChange = (countriesList: string[]) => {
    setSelectedCountryValue(countriesList );
  };
  return (
    <div className="dashboard-wrap">
      <div className="top-content">
        <Row gutter={25}>
          <Col flex={200}>
            <Title level={4}>Avatar Overview</Title>
          </Col>
          <Col flex={6}>
          <ProviderCountrySelect onChange={handleCountryChange} />
           
          </Col>

          <Col flex={6}>
                      <RangePicker
                        style={{ width: 300 }}
                        allowClear={false}
                        value={[startDate, endDate]}
                        disabledDate={(current) =>
                          current && current > dayjs().endOf('day')
                        }
                        onChange={(dates) => {
                          if (dates) {
                            setStartDate(dates[0])
                            setEndDate(dates[1])
                          } else {
                            setStartDate(null)
                            setEndDate(null)
                          }
                        }}
                        format={'YYYY-MM-DD'}
                      />
                    </Col>
        </Row>
      </div>

      <div>
       <Row gutter={25} >
             
       <Col span={7} >
         <Card
           style={{
             borderRadius: '10px',
             padding: '1rem',
             color: 'white',
           }}
           bodyStyle={{ padding: 0 }}
         >
           <div style={{ marginBottom: '0.1rem', fontSize: '14px', color: '#ccc' }}>
             Total Characters
           </div>
       
           <div style={{ fontSize: '22px', color: '#3A63FF', fontWeight: 600 }}>
             {(metricsData?.totalAvatarCount ?? 0).toLocaleString()}
           </div>
         </Card>
       </Col>
       
       
       <Col span={7} >
         <Card
           style={{
             borderRadius: '10px',
             padding: '1rem',
             color: 'white',
           }}
           bodyStyle={{ padding: 0 }}
         >
           <div style={{ marginBottom: '0.1rem', fontSize: '14px', color: '#ccc' }}>
             Total Custom Avatars
           </div>
       
           <div style={{ fontSize: '22px', color: '#3A63FF', fontWeight: 600 }}>
             {(metricsData?.totalCustomCharacterCount ?? 0).toLocaleString()}
           </div>
         </Card>
       </Col>
       
       
             <Col span={10}>
         <Card
           style={{
             borderRadius: '10px',
             padding: '1rem',
             color: 'white',
           }}
           bodyStyle={{ padding: 0 }}
         >
           <div style={{ marginBottom: '0.1rem', fontSize: '14px', color: '#ccc' }}>
             Total Avatar Used by User
           </div>
       
           <div style={{ fontSize: '22px', color: '#3A63FF', fontWeight: 600 }}>
             {(metricsData?.totalAvatarCount + metricsData?.totalCustomCharacterCount).toLocaleString()}
           </div>
         </Card>
       </Col>
           </Row>
           </div>
           <div className="middle-content" style={{ marginTop: 20 }}>
        <Row gutter={25}>
          <Col span={14} style={{ display: 'flex', height: 420, width: 400 }}>
            <Card
              ref={(el) => (cardRefs.current[2] = el)}
              title="Total Avatars"
              style={{ flex: 1 }}
              extra={
                <Button
                  type="primary"
                  className="no-snapshot"
                  style={{
                    background: 'transparent',
                    borderColor: 'transparent',
                  }}
                  shape="circle"
                  icon={<DownloadOutlined />}
                  onClick={() => handleDownload(2)}
                />
              }
            >
              

              <div style={{ display: 'flex', height: 420, width: 400 }}>
                <AvatarCustomTimeseries
                  data={avatarChart}
                  chartHeight={250}
                  
                />
              </div>
            </Card>
          </Col>

          <Col span={10} style={{ display: 'flex', height: 420 ,justifyContent:'center', alignItems:'center'}}>
            <Card
              ref={(el) => (cardRefs.current[3] = el)}
              title="Avatar Type"
              style={{ flex: 1 }}
              extra={
                <Button
                  type="primary"
                  className="no-snapshot"
                  style={{
                    background: 'transparent',
                    borderColor: 'transparent',
                  }}
                  shape="circle"
                  icon={<DownloadOutlined />}
                  onClick={() => handleDownload(3)}
                />
              }
            >
              <AvatarPieChart
                data={pieChartData}
                colorKey={'Characters'}
                pieColors={['#648858', '#4754a6']}
              />
            </Card>
          </Col>

     
        </Row>
      </div>

      <div className="bottom-content" style={{ marginTop: 20 }}>
        <Row gutter={25}>
          <Col span={12}>
            <Card className="list-card">
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: 16,
                }}
              >
                <Title level={4} style={{ margin: 0 }}>
                  Top 10 Avatars
                </Title>
                
              </div>
              <div >
                <Table
                  dataSource={top10AvatarData}
                  loading={top10AvatarsLoading}
                  pagination={false}
                  
                >
                  <Table.Column
                    title="Avatar"
                    dataIndex="name"
                    key="name"
                    
                  />
                  <Table.Column
                    title="No. of Times Used"
                    dataIndex="usageCount"
                    key="usageCount"
                  />
                </Table>
              </div>
            </Card>
          </Col>
          <Col span={12}>
            <Card className="list-card">
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: 16,
                }}
              >
                <Title level={4} style={{ margin: 0 }}>
                  Top 10 Custom Avatars
                </Title>
               
              </div>
              <div >
                <Table
                  dataSource={top10CustomAvatarData}
                  loading={top10CustomAvatarsloading}
                  pagination={false}
                 
                >
                  <Column title="Avatar" dataIndex="name" key="name" />
                  <Column title="No. of Times Used" dataIndex="usageCount" key="usageCount" />
                </Table>
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default AvatarOverview
